module.exports = __webpack_public_path__ + "img/rt-min2.af35cda1.svg";